const riot = require('riot');

riot.tag2('popup-action-sheet', '<div class="f fc fclm rounded-8 bg-white box-shadow border" ref="popup"> <div class="f fm {option.alert ? \'text-primary\' : \'text-label_high\'}" data-is="item-selection-list" onclick="{onClickSelect}" each="{option in opts.options}"> <div class="f fm px8 py6"><i class="fs16 mr4 icon-{option.icon}"></i> <div class="word-break-keep">{option.label}</div> </div> </div> </div>', '', '', function(opts) {
    this.on('mount', () => {
      document.addEventListener('keydown', (e) => {
        this.selectionList.onKeyDown(e);
      });
    });

    this.on('unmount', () => {
      document.removeEventListener('keydown', this.selectionList.onKeyDown);
    });

    this.mixin('selectionList');

    this.on('selectionList.keydown.enter', (e) => {
      e.preventDefault();
      this.select();
    });

    this.onClickSelect = (e) => {
      this.trigger("select", {option: e.item.option});
    };

    this.select = () => {
      var index = this.selectionList.selectedIndex;
      var option = this.opts.options[index];
      this.trigger("select", { option });
    };
});